import {Component, Input} from '@angular/core';
import {Severity} from '../../../../types/severity';

@Component({
  selector: 'mc-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss'],
})
export class NotificationCardComponent {
  @Input() severity: Severity = 'primary';
}
